module.exports = __webpack_public_path__ + "img/pantalla-4-6--mobile.6addc146.png";